// // src/components/callLogs/BulkUploadModal.jsx
// import React, { useState, useRef } from "react";
// import {
//   X, Upload, FileSpreadsheet, Download,
//   CheckCircle2, AlertCircle, Loader2,
// } from "lucide-react";
// import "./BulkUploadModal.css";

// const BASE_URL = "https://apicrm.zenrealestate.in/api";

// export default function BulkUploadModal({ open, onClose, onDone }) {
//   const [file,     setFile]     = useState(null);
//   const [dragging, setDragging] = useState(false);
//   const [loading,  setLoading]  = useState(false);
//   const [result,   setResult]   = useState(null);
//   const [error,    setError]    = useState("");
//   const inputRef = useRef();

//   if (!open) return null;

//   const reset = () => { setFile(null); setResult(null); setError(""); };
//   const handleClose = () => { reset(); onClose(); };

//   const pickFile = (f) => {
//     if (!f) return;
//     const ext = f.name.split(".").pop().toLowerCase();
//     if (!["xlsx", "xls", "csv"].includes(ext)) {
//       setError("Only .xlsx, .xls, .csv files allowed."); return;
//     }
//     setError(""); setResult(null); setFile(f);
//   };

//   const onDrop = (e) => {
//     e.preventDefault(); setDragging(false);
//     pickFile(e.dataTransfer.files[0]);
//   };

//   const handleUpload = async () => {
//     if (!file) return;
//     setLoading(true); setError(""); setResult(null);
//     try {
//       // Get token directly â€” same way api.js interceptor does it
//       const token = localStorage.getItem("token");

//       const fd = new FormData();
//       fd.append("file", file);

//       const res = await fetch(`${BASE_URL}/call-logs/bulk`, {
//         method: "POST",
//         headers: {
//           // DO NOT set Content-Type â€” browser sets multipart boundary automatically
//           Authorization: `Bearer ${token}`,
//         },
//         body: fd,
//       });

//       const data = await res.json();

//       if (!res.ok) {
//         setError(data.message || `Error ${res.status}`);
//         return;
//       }

//       setResult(data);
//       if (data.created > 0) onDone();
//     } catch (e) {
//       setError("Upload failed. Check server is running.");
//     } finally { setLoading(false); }
//   };

//   const downloadTemplate = () => {
//     const headers = [
//       "clientName","contactNumber","address","callDate",
//       "propertyDetails","meetingScheduled","visit","currentStatus","remarks"
//     ].join(",");
//     const s1 = "Virat Kohli,9512067892,Vadodara,2026-05-01,3BHK near lake,2026-05-05,Scheduled,Interested,Very keen";
//     const s2 = "Rohit Sharma,9876543210,Ahmedabad,2026-05-02,Commercial shop,,Pending,New,Will call back";
//     const csv  = [headers, s1, s2].join("\n");
//     const blob = new Blob([csv], { type: "text/csv" });
//     const url  = URL.createObjectURL(blob);
//     const a    = document.createElement("a");
//     a.href = url; a.download = "CallLog_BulkUpload_Template.csv"; a.click();
//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className="bum-overlay" onClick={handleClose}>
//       <div className="bum-panel" onClick={(e) => e.stopPropagation()}>

//         <div className="bum-header">
//           <div className="bum-title-wrap"><Upload size={20}/><h2>Bulk Upload Call Logs</h2></div>
//           <button className="bum-close" onClick={handleClose}><X size={18}/></button>
//         </div>

//         <div className="bum-body">
//           <div className="bum-template-bar">
//             <div>
//               <p className="bum-template-title">Download Template</p>
//               <p className="bum-template-sub">Required: clientName, contactNumber.</p>
//             </div>
//             <button className="bum-template-btn" onClick={downloadTemplate}>
//               <Download size={14}/> Template CSV
//             </button>
//           </div>

//           {!result && (
//             <div
//               className={`bum-dropzone ${dragging ? "drag" : ""} ${file ? "has-file" : ""}`}
//               onClick={() => inputRef.current?.click()}
//               onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
//               onDragLeave={() => setDragging(false)}
//               onDrop={onDrop}
//             >
//               <input
//                 ref={inputRef} type="file" accept=".xlsx,.xls,.csv"
//                 style={{ display: "none" }}
//                 onChange={(e) => pickFile(e.target.files[0])}
//               />
//               {file ? (
//                 <div className="bum-file-info">
//                   <FileSpreadsheet size={32} color="#6366f1"/>
//                   <p className="bum-file-name">{file.name}</p>
//                   <p className="bum-file-size">{(file.size / 1024).toFixed(1)} KB</p>
//                   <button className="bum-remove" onClick={(e) => { e.stopPropagation(); setFile(null); }}>
//                     Remove
//                   </button>
//                 </div>
//               ) : (
//                 <div className="bum-drop-hint">
//                   <FileSpreadsheet size={36} color="#9ca3af"/>
//                   <p>Drop your Excel / CSV here</p>
//                   <span>or click to browse</span>
//                   <p className="bum-formats">.xlsx Â· .xls Â· .csv</p>
//                 </div>
//               )}
//             </div>
//           )}

//           {error && <div className="bum-error-box"><AlertCircle size={16}/> {error}</div>}

//           {result && (
//             <div className="bum-result">
//               <div className="bum-result-summary">
//                 <div className="bum-stat success">
//                   <CheckCircle2 size={20}/>
//                   <div><p className="bum-stat-val">{result.created}</p><p className="bum-stat-label">Imported</p></div>
//                 </div>
//                 <div className={`bum-stat ${result.failed > 0 ? "fail" : "zero"}`}>
//                   <AlertCircle size={20}/>
//                   <div><p className="bum-stat-val">{result.failed}</p><p className="bum-stat-label">Failed</p></div>
//                 </div>
//               </div>
//               {result.errors?.length > 0 && (
//                 <div className="bum-errors-list">
//                   <p className="bum-errors-title">Row errors:</p>
//                   {result.errors.map((e, i) => (
//                     <div key={i} className="bum-error-row">
//                       <span className="bum-row-num">Row {e.row}</span>
//                       <span className="bum-row-reason">{e.reason}</span>
//                     </div>
//                   ))}
//                 </div>
//               )}
//               <button className="bum-upload-again" onClick={reset}>Upload Another File</button>
//             </div>
//           )}
//         </div>

//         {!result && (
//           <div className="bum-footer">
//             <button className="bum-btn-cancel" onClick={handleClose}>Cancel</button>
//             <button className="bum-btn-upload" onClick={handleUpload} disabled={!file || loading}>
//               {loading
//                 ? <><Loader2 size={15} className="bum-spin"/> Uploadingâ€¦</>
//                 : <><Upload size={15}/> Upload</>}
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
// src/components/callLogs/BulkUploadModal.jsx
import React, { useState, useRef } from "react";
import {
  X, Upload, FileSpreadsheet, Download,
  CheckCircle2, AlertCircle, Loader2,
} from "lucide-react";
import "./BulkUploadModal.css";

const BASE_URL = "https://apicrm.zenrealestate.in/api";

export default function BulkUploadModal({ open, onClose, onDone }) {
  const [file,     setFile]     = useState(null);
  const [dragging, setDragging] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [result,   setResult]   = useState(null);
  const [error,    setError]    = useState("");
  const inputRef = useRef();

  if (!open) return null;

  const reset = () => { setFile(null); setResult(null); setError(""); };
  const handleClose = () => { reset(); onClose(); };

  const pickFile = (f) => {
    if (!f) return;
    const ext = f.name.split(".").pop().toLowerCase();
    if (!["xlsx", "xls", "csv"].includes(ext)) {
      setError("Only .xlsx, .xls, .csv files allowed."); return;
    }
    setError(""); setResult(null); setFile(f);
  };

  const onDrop = (e) => {
    e.preventDefault(); setDragging(false);
    pickFile(e.dataTransfer.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;
    setLoading(true); setError(""); setResult(null);
    try {
      const token = localStorage.getItem("token");
      const fd = new FormData();
      fd.append("file", file);

      const res = await fetch(`${BASE_URL}/call-logs/bulk`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd,
      });

      const data = await res.json();
      if (!res.ok) { setError(data.message || `Error ${res.status}`); return; }

      setResult(data);
      if (data.created > 0) onDone();
    } catch (e) {
      setError("Upload failed. Check server is running.");
    } finally { setLoading(false); }
  };

  const downloadTemplate = () => {
    // â† propertyAddress column added
    const headers = [
      "clientName","contactNumber","address","callDate",
      "propertyDetails","propertyAddress",
      "meetingScheduled","visit","currentStatus","remarks"
    ].join(",");
    const s1 = "Virat Kohli,9512067892,Vadodara,2026-05-01,3BHK near lake,Near Vadodara Lake Opp Gate 3,2026-05-05,Scheduled,Interested,Very keen";
    const s2 = "Rohit Sharma,9876543210,Ahmedabad,2026-05-02,Commercial shop,,Sarkhej Road,,Pending,New,Will call back";
    const csv = [headers, s1, s2].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href = url; a.download = "CallLog_BulkUpload_Template.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="bum-overlay" onClick={handleClose}>
      <div className="bum-panel" onClick={(e) => e.stopPropagation()}>

        <div className="bum-header">
          <div className="bum-title-wrap"><Upload size={20}/><h2>Bulk Upload Call Logs</h2></div>
          <button className="bum-close" onClick={handleClose}><X size={18}/></button>
        </div>

        <div className="bum-body">
          <div className="bum-template-bar">
            <div>
              <p className="bum-template-title">Download Template</p>
              <p className="bum-template-sub">Required: clientName, contactNumber. Includes propertyAddress.</p>
            </div>
            <button className="bum-template-btn" onClick={downloadTemplate}>
              <Download size={14}/> Template CSV
            </button>
          </div>

          {!result && (
            <div
              className={`bum-dropzone ${dragging ? "drag" : ""} ${file ? "has-file" : ""}`}
              onClick={() => inputRef.current?.click()}
              onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
              onDragLeave={() => setDragging(false)}
              onDrop={onDrop}
            >
              <input
                ref={inputRef} type="file" accept=".xlsx,.xls,.csv"
                style={{ display: "none" }}
                onChange={(e) => pickFile(e.target.files[0])}
              />
              {file ? (
                <div className="bum-file-info">
                  <FileSpreadsheet size={32} color="#6366f1"/>
                  <p className="bum-file-name">{file.name}</p>
                  <p className="bum-file-size">{(file.size / 1024).toFixed(1)} KB</p>
                  <button className="bum-remove" onClick={(e) => { e.stopPropagation(); setFile(null); }}>Remove</button>
                </div>
              ) : (
                <div className="bum-drop-hint">
                  <FileSpreadsheet size={36} color="#9ca3af"/>
                  <p>Drop your Excel / CSV here</p>
                  <span>or click to browse</span>
                  <p className="bum-formats">.xlsx Â· .xls Â· .csv</p>
                </div>
              )}
            </div>
          )}

          {error && <div className="bum-error-box"><AlertCircle size={16}/> {error}</div>}

          {result && (
            <div className="bum-result">
              <div className="bum-result-summary">
                <div className="bum-stat success">
                  <CheckCircle2 size={20}/>
                  <div><p className="bum-stat-val">{result.created}</p><p className="bum-stat-label">Imported</p></div>
                </div>
                <div className={`bum-stat ${result.failed > 0 ? "fail" : "zero"}`}>
                  <AlertCircle size={20}/>
                  <div><p className="bum-stat-val">{result.failed}</p><p className="bum-stat-label">Failed</p></div>
                </div>
              </div>
              {result.errors?.length > 0 && (
                <div className="bum-errors-list">
                  <p className="bum-errors-title">Row errors:</p>
                  {result.errors.map((e, i) => (
                    <div key={i} className="bum-error-row">
                      <span className="bum-row-num">Row {e.row}</span>
                      <span className="bum-row-reason">{e.reason}</span>
                    </div>
                  ))}
                </div>
              )}
              <button className="bum-upload-again" onClick={reset}>Upload Another File</button>
            </div>
          )}
        </div>

        {!result && (
          <div className="bum-footer">
            <button className="bum-btn-cancel" onClick={handleClose}>Cancel</button>
            <button className="bum-btn-upload" onClick={handleUpload} disabled={!file || loading}>
              {loading
                ? <><Loader2 size={15} className="bum-spin"/> Uploadingâ€¦</>
                : <><Upload size={15}/> Upload</>}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}